import { IQuickSortState } from "../../IQuickSortState";
import { IQuickSortContext } from '../../IQuickSortContext';
import { QuickSortStep } from '../../enums/QuickSortStep';
import { assertIsDefined } from "../../../tsutils/assertIsDefined";
import { QuickSortCallState } from "./QuickSortCallState";

export class QuickSortInitState implements IQuickSortState {

  ThisQuickSortStep = QuickSortStep.QuickSortInit;
  
  Description = "Initialize QuickSort (accept values from outside)";

  private _context : IQuickSortContext | undefined;
  
  SetContext(context: IQuickSortContext): void {
    this._context = context;
  } 
  
  Do(): void {
    assertIsDefined(this._context);
    assertIsDefined(this._context.Numbers);
    assertIsDefined(this._context.AlgoStack);
  }

  Undo(): void {
    assertIsDefined(this._context);
    assertIsDefined(this._context.Numbers);
    assertIsDefined(this._context.AlgoStack);
  }

  Exit(): void {
    if (this._context) {
      this._context.TransitionTo(new QuickSortCallState());
    }
  }
}